export const FILE_CODE_COPY = {
  NOT_FOUND: 'File no longer exists',
  NOT_IN_PROJECT: 'File belongs to a different project',
  PENDING_OPERATION: 'An operation is still running on this file',
  ALREADY_EXCLUDED: 'File is already excluded',
  NOT_EXCLUDED: 'File is not excluded',
  NOT_CONVERTED: 'Not converted to PDF',
  EXCLUDED: 'Excluded from the project',
  DUPLICATE: 'Listed twice',
  COMBINED: 'Combined documents are not compared directly',
  COMBINED_SOURCE: 'Source is hidden by a combined document; uncombine it first'
}
export const fileCodeCopy = (code, fallback) => FILE_CODE_COPY[code] || fallback

export const RENAME_ERRORS = {
  PENDING_OPERATION: "Can't rename while an operation is running on this file.",
  EXTENSION_CHANGED: "The extension can't be changed.",
  NAME_TOO_LONG: 'The name is over 255 characters.',
  NAME_INVALID: "The name can't contain a slash or a control character."
}
export const ORDER_ERRORS = {
  STALE_ORDER: 'The file list changed while you were reordering. It has been refreshed. Try again.',
  PENDING_OPERATION: "Can't reorder while an operation is running on a file here. The list has been refreshed."
}

const OPERATION_VERB = { convert: 'convert', combine: 'combine', prepare: 'prepare' }
export function operationFailure(kind, failedNames = []) {
  const what = failedNames.length ? failedNames.join(', ') : 'the selected files'
  const why = kind === 'convert' ? ' The file may be damaged, or its format may not be supported.' : ''
  return `Couldn't ${OPERATION_VERB[kind] || 'finish'} ${what}.${why}`
}
